import React, { useState, useRef, useEffect } from "react";
import "./DropdownList.css";
import { Globals } from "../../global/Globals";

const DropdownListWithObject = ({
  inputValue,
  options,
  onSelect,
  placeHolderValue,
  selectClass,
  selectedItem,
  selectedValues,
  disabled,
  tabIndex,
  valueToReset,
  onBlur,
  dropdowncontainerclass,
  error,
  CustomDropdownimg,
}) => {
  const [selectedOption, setSelectedOption] = useState(inputValue || "");
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  let extraProps = {};
  if (tabIndex) {
    extraProps.tabindex = tabIndex;
    if (onBlur) {
      extraProps.onBlur = onBlur;
    }
  }
  useEffect(() => {
    setSelectedOption(selectedItem || selectedValues || inputValue);
  }, [selectedItem, selectedValues, inputValue]);
  const handleChange = (event) => {
    if (event.target) {
      const value = event.target.innerText;
      setSelectedOption(value);
      onSelect(value);
      setIsOpen(false);
    } else {
      const value = event;
      setSelectedOption(value);
      onSelect(value);
      setIsOpen(false);
    }
  };
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const collapseDropdown = () => {
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  /*this is to reset province selectedOption when country gets changed and not to show the selected values.
   Kindly do not delete this, once the requirement is finalised this can checked and removed*/
  useEffect(() => {
    if (valueToReset) {
      setSelectedOption("");
    }
  }, [valueToReset]);
  return (
    <div
      className={`dropdownList ${
        selectedOption ? "create-brief-dropdown-selected" : ""
      } ${disabled && " dropdown-disabled"} create-brief-dropdown`}
      ref={dropdownRef}
      {...extraProps}
    >
      <div
        className={"dropdownList-title"}
        onClick={disabled ? () => {} : toggleDropdown}
        onBlurCapture={collapseDropdown}
      >
        {selectedOption?.constructor === Object ? (
          <div className={`title ${selectedOption?.name && "selected-items"}`}>
            {selectedOption ? selectedOption?.name : placeHolderValue}
          </div>
        ) : (
          <div className={`title ${selectedOption && "selected-items"}`}>
            {selectedOption ? selectedOption : placeHolderValue}
          </div>
        )}
        <div className={`${CustomDropdownimg} "dropdownList-img"`}>
          <img
            className="dropdownList-img"
            src={Globals.IMG.DROPDOWN}
            alt="dropdownList"
          />
        </div>
      </div>
      {isOpen && options.length > 0 && (
        <div className={`dropdownList-content ${dropdowncontainerclass}`}>
          {options.map((option) => {
            if (option.constructor === Object) {
              return (
                <div
                  key={option.id}
                  className="dropdownList-Item"
                  onClick={() => handleChange(option)}
                >
                  <label htmlFor={option.name} className="option-label-list">
                    {option.name}
                  </label>
                </div>
              );
            } else {
              return (
                <div
                  key={option}
                  className="dropdownList-Item"
                  onClick={handleChange}
                >
                  <label htmlFor={option} className="option-label-list">
                    {option}
                  </label>
                </div>
              );
            }
          })}
        </div>
      )}
    </div>
  );
};

export default DropdownListWithObject;
